// 是否是启动企业知识库的页面
export const isEnableEnterpriseKbPage = () => {
  const pathname = location.pathname
  return ['/teamhome', '/chat'].some(p => pathname.startsWith(p))
}

export const noRewriteApis = [
  '/user/coin/balance',
  '/task/list',
  '/membership/usage',
  '/membership/info',
  '/img/vip/config',
  '/user/detail/info',
  '/knw_cloud/inRouter/v1/knowledge/cloud/user/info'
]

export const isNoRewriteApi = (api: string) => {
  return noRewriteApis.some((p) => api.includes(p))
}
